import { render, staticRenderFns } from "./ChangePriorityConfig.vue?vue&type=template&id=e1a59674&scoped=true"
import script from "./ChangePriorityConfig.vue?vue&type=script&lang=js"
export * from "./ChangePriorityConfig.vue?vue&type=script&lang=js"
import style0 from "./ChangePriorityConfig.vue?vue&type=style&index=0&id=e1a59674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a59674",
  null
  
)

export default component.exports